import { useTranslation } from "react-i18next"
import { Modal } from "../../common"
import { Button } from "../../App.styles"

const NubImageUploadModal = ({ onDismiss, show }) => {
    const { t } = useTranslation()

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title">{t(`Transformation References`)}</h4>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p dangerouslySetInnerHTML={{__html:t('Attach reference images to your transformation instructions.')}}/>
                <ul>
                    <li dangerouslySetInnerHTML={{__html:t('Images can utilize text inside the image.')}}/>
                    <li dangerouslySetInnerHTML={{__html:t('Provide expected results as an example.')}}/>
                    <li dangerouslySetInnerHTML={{__html:t('Show multiple steps for better results on complex transformations.')}}/>
                </ul>
            </div>
            <div className="modal-footer">
                <Button color="dark" data-dismiss="modal" onClick={onDismiss}>
                    {t('Close')}
                </Button>
            </div>
        </Modal>
    )
}

export default NubImageUploadModal
